import { render, staticRenderFns } from "./ProductBulkImageUploadGuide.vue?vue&type=template&id=be12edd4&"
import script from "./ProductBulkImageUploadGuide.vue?vue&type=script&lang=ts&"
export * from "./ProductBulkImageUploadGuide.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports